import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { selectDefinedFieldTypes } from 'modules/catalogFieldTypes/selectors';
import { selectIsCatalogCollectionsFlagOn } from 'core/userContext';
import { updateCatalogItemRequest, updateFieldsAndCatalogItemRequest } from '../actions';
import CatalogFormJSON from './CatalogFormJSON';

// type Props = {
//   isCatalogCollectionsFlagOn: boolean,
// };

export class CatalogFormJSONContainer extends React.Component {
  render() {
    return <CatalogFormJSON {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  component: CatalogFormJSON,
  isCatalogCollectionsFlagOn: selectIsCatalogCollectionsFlagOn(state),
  definedFields: selectDefinedFieldTypes(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateCatalogItemRequest,
      updateFieldsAndCatalogItemRequest,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CatalogFormJSONContainer));
